<button (click)="toggleLiveDemo()" cButton>Votar</button>

<c-modal #verticallyCenteredModal [visible]="visible" alignment="center" id="verticallyCenteredModal">
    <c-modal-body>
        <div class="container-fluid" *ngIf="!ingresoCodigo">
            <div class="row">
                <div class="col-12">
                    <p>
                        Ingresa tu número de teléfono sin espacios ni guiones para recibir tu código de validación.
                    </p>
                </div>
            </div>
            <form class="row container-info" [formGroup]="formulario">
                <div class="col-12 d-flex justify-content-center align-items-center">
                    <div class="containerInput col-6">
                        <div class="seleccionPais">
                            <ng-select formControlName="codigoPais">
                                <ng-option *ngFor="let ext of extensionesPorPais"
                                    [value]="ext.extension">{{ext.extension}} - {{ext.pais}}</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="containerInput col-6">
                        <div class="numeroDeTelefono">
                            <input class="form-control" type="tel" name="numeroDeTelefono" id="numeroDeTelefono"
                                placeholder="Número de teléfono" formControlName="numero" minlength="8">
                        </div>
                    </div>
                </div>
                <div class="col-12 m-auto pt-2" style="font-size: 0.9em;">
                    <div class="row">
                        <div class="form-group form-check"
                            style="text-align: center;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                            <input type="checkbox" class="form-check-input" id="verificacion"
                                formControlName="verificacion" style="width: 35px;height: 35px;" #verificacion>
                            <label class="form-check-label" for="verificacion">
                                Estoy de acuerdo en recibir un mensaje de
                                texto por parte de Guatemaltecos Ilustres para validar mi voto. Es posible que se
                                apliquen tarifas de datos de su operador local. Responde STOP para darse de
                                baja.
                                <a href="#/politicas" target="_blank">
                                    Ver Políticas de Privacidad
                                </a>
                            </label>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row">
                <button type="button" id="enviar" class="btn btn-primary btn-enviar"
                    [disabled]="formulario.invalid || !formulario.value.verificacion" (click)="votar()">Enviar</button>
            </div>
        </div>
        <div class="container-fluid" *ngIf="ingresoCodigo">
            <div class="row">
                <div class="col-12">
                    <p>
                        Ingresa tu código de verificación, para votar.
                    </p>
                </div>
            </div>
            <div class="row container-info" [formGroup]="formularioVerificacion">
                <div class="col-12 d-flex justify-content-center align-items-center">
                    <div class="containerInput col-12">
                        <div class="numeroDeTelefono">
                            <input class="form-control" type="text" name="numeroDeTelefono" id="numeroDeTelefono"
                                placeholder="Ingrese su código" formControlName="codigo" maxlength="4">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <button type="button" id="enviar" class="btn btn-primary btn-enviar" [disabled]="formulario.invalid"
                    (click)="validarCodigo()">Enviar</button>
            </div>
        </div>
    </c-modal-body>
</c-modal>